import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { COMMON_DEFAULT_STYLES } from '../../shared/constants.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Buffer height to ensure the textarea is always slightly larger than its content.
 * This prevents the scrollbar from appearing immediately when typing.
 */
var SCROLL_BUFFER_HEIGHT = 2;

/**
 * Maps custom resize tokens to native CSS `resize` property values.
 */
var RESIZE_VALUE_MAP = {
  horizontal: 'horizontal',
  vertical: 'vertical',
  auto: 'both',
  smart: 'none',
  // Special case: resize is handled programmatically
  none: 'none'
};

/**
 * Default properties for the Textarea component.
 * Ensures consistent behavior and appearance across different instances.
 */
var DEFAULT_PROPS_VALUES = {
  resize: 'smart',
  minHeight: '80px',
  maxHeight: '25dvh',
  rows: 3
};

// Default styles for the clear button in the Textarea component.
var CLEAR_BUTTON_DEFAULT_STYLES = {
  position: 'absolute',
  end: '6px',
  top: '6px'
};

// Default styles for the Textarea component.
var TEXTAREA_DEFAULT_STYLES = _objectSpread(_objectSpread({}, COMMON_DEFAULT_STYLES), {}, {
  borderRadius: {
    value: '8'
  },
  height: '100%',
  p: '12'
});

// Default styles for the Textarea container.
var TEXTAREA_CONTAINER_DEFAULT_STYLES = {
  borderColor: 'base.intent',
  border: {
    value: '1'
  },
  borderStyle: 'solid',
  display: 'flex',
  alignItems: 'flex-start',
  borderRadius: {
    value: '8'
  },
  width: '100%',
  px: '0',
  my: '8',
  gap: '8',
  position: 'relative',
  overflow: 'auto'
};

export { CLEAR_BUTTON_DEFAULT_STYLES, DEFAULT_PROPS_VALUES, RESIZE_VALUE_MAP, SCROLL_BUFFER_HEIGHT, TEXTAREA_CONTAINER_DEFAULT_STYLES, TEXTAREA_DEFAULT_STYLES };
//# sourceMappingURL=constants.js.map
